module.exports = __webpack_public_path__ + "img/documents.32e2eb03.gif";